(function () {
  'use strict';

  var tileGrid = document.querySelector('nc-search-tile-grid, nc-tile-grid');
  if (!tileGrid) return;

  var catalogRoot = tileGrid.parentElement || tileGrid;
  var tileContainer = tileGrid.querySelector('.tile-grid__tiles');
  var loader = catalogRoot.querySelector('.tile-grid__loader');
  var sortPopup = tileGrid.querySelector('.tile-grid__sorting-popup');
  var sortButton = tileGrid.querySelector('.btn-sort');
  var sortClose = tileGrid.querySelector('.tile-grid__sorting-close');
  var filterButton = document.getElementById('filters-trigger');
  var filterDrawer = document.getElementById('filters-drawer');
  var filterClose = filterDrawer && filterDrawer.querySelector('.drawer__close');
  var filterBackdrop = document.getElementById('filters-backdrop');

  function syncPressed(selector) {
    document.querySelectorAll(selector).forEach(function (control) {
      control.setAttribute(
        'aria-pressed',
        control.classList.contains('active') ? 'true' : 'false'
      );
    });
  }

  function syncAccordion() {
    if (!filterDrawer) return;

    filterDrawer.querySelectorAll('.accordion-item').forEach(function (item) {
      var trigger = item.querySelector('.accordion-trigger');
      if (trigger) {
        trigger.setAttribute(
          'aria-expanded',
          item.classList.contains('active') ? 'true' : 'false'
        );
      }
    });
  }

  function syncBusyState() {
    if (!tileContainer) return;

    var hasSkeleton = Boolean(
      tileContainer.querySelector('.nc-search-skeleton')
    );
    var isFetching = Boolean(
      loader && !loader.classList.contains('hidden')
    );

    tileContainer.setAttribute(
      'aria-busy',
      hasSkeleton || isFetching ? 'true' : 'false'
    );
  }

  function sync() {
    syncPressed('.tile-grid__sort-bar-choice');
    syncPressed('.tile-grid__layout-selector');
    syncPressed('.filter-option');
    syncAccordion();
    syncBusyState();

    if (sortPopup && sortButton) {
      var sortOpen = sortPopup.classList.contains('open');
      sortButton.setAttribute('aria-expanded', sortOpen ? 'true' : 'false');
      sortPopup.setAttribute('aria-hidden', sortOpen ? 'false' : 'true');
    }

    if (filterDrawer && filterButton) {
      filterButton.setAttribute(
        'aria-expanded',
        filterDrawer.classList.contains('open') ? 'true' : 'false'
      );
    }
  }

  var observer = new MutationObserver(sync);
  observer.observe(catalogRoot, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true
  });

  if (filterDrawer && !catalogRoot.contains(filterDrawer)) {
    observer.observe(filterDrawer, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target.closest(
        '.btn-sort, .tile-grid__sorting-close, #filters-trigger, .drawer__close, #filters-backdrop'
      );

      if (!target) return;

      window.requestAnimationFrame(function () {
        if (
          target === filterBackdrop &&
          sortPopup &&
          sortPopup.classList.contains('open') &&
          sortClose
        ) {
          sortClose.click();
        }

        sync();

        if (
          target === sortButton &&
          sortPopup &&
          sortPopup.classList.contains('open') &&
          sortClose
        ) {
          sortClose.focus();
        } else if (target === sortClose && sortButton) {
          sortButton.focus();
        } else if (
          target === filterButton &&
          filterDrawer &&
          filterDrawer.classList.contains('open') &&
          filterClose
        ) {
          filterClose.focus();
        } else if (
          (target === filterClose || target === filterBackdrop) &&
          filterButton
        ) {
          filterButton.focus();
        }
      });
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    if (sortPopup && sortPopup.classList.contains('open') && sortClose) {
      event.preventDefault();
      sortClose.click();
      if (sortButton) sortButton.focus();
      return;
    }

    if (
      filterDrawer &&
      filterDrawer.classList.contains('open') &&
      filterClose
    ) {
      event.preventDefault();
      filterClose.click();
      if (filterButton) filterButton.focus();
    }
  });

  sync();
})();
